export default __webpack_public_path__ + "static/media/cut-gold.f62a583c.svg";